import { isSDKInitialized } from './LiveLikeService';

export const fetchSDKRewardBalance = async (sdkClient, rewardItemIds) => {
    if (!isSDKInitialized(sdkClient)) return [];

    try {
        const response = await sdkClient.getRewardItemBalances({ rewardItemIds });
        return response?.results || [];
    } catch (e) {
        return [];
    }
};
